export default {
  1: "Ready",
  2: "Open",
  6: "Downloaded",
  7: "Loading",
  9: "Departed",
  11: "Offline",
  13: "In Build",
};
